export enum CLAIMS_DOMAIN {
  STORES_ACTOR = 'storeActor',
  CLAIMS = 'claims',
  SOLUTIONS = 'solutions',
}

export const CLAIMS_DOMAIN_KEY = 'claims';
